import {
  CircularProgressProps,
  Box,
  CircularProgress,
  circularProgressClasses,
  Stack,
} from "@mui/material";

function FacebookCircularProgress(props: CircularProgressProps) {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={70}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette.mode === "light" ? "#E94F11" : "#E94F11",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={70}
        thickness={4}
        {...props}
      />
    </Box>
  );
}

interface ILoading {
  height?: boolean;
}

export default function Loading({ height }: ILoading) {
  return (
    <Stack
      height={height ? "100vh" : "auto"}
      width="100%"
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <FacebookCircularProgress />
    </Stack>
  );
}
